<template>
    <section class="timer-alert-logout" v-show="this.$store.state.mostrarAlertaTimeOut">
        <div class="custom-card">
            <div class="custom-card-header">
                <h4 class="custom-card-header-title">La Sesión Expirará</h4>
            </div>
            <div class="custom-card-body">
                <span class="timer-logout-title"><i class="icon-shield"></i> <span class="timer-logout-title-title">Su sesión va a expirar en:</span></span>
                <span class="timer-logout-time">
                 {{texto_minutos}} {{ this.$store.state.segundos }} Segundos
                </span>
                <p class="text-center">Ingrese a cualquier otra seccion del sistema para refrescar su sesión</p>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "TimerLogOut",
      computed:{
        texto_minutos(){
          if(this.$store.state.minutos > 0)
            return `${this.$store.state.minutos } Minutos`;
          else
            return '';
        }
      }
    }
</script>

<style scoped>
    .timer-alert-logout {
        position: fixed;
        right: 40%;
        top: 66px;
    }

    .custom-card {
        max-width: 320px;
        background-color: #ffffff;
    }

    .custom-card-header {
        background-color: #eb5d57;
        padding: 7px;
        border-radius: 3px;
        text-align: center;
    }

    .custom-card-header-title {
        color: #ffffff;
    }


    .custom-card-body {
        display: flex;
        flex-flow: column wrap;
        align-items: center;
        justify-content: center;
        padding: 12px;
    }

    .timer-logout-time {
        font-size: 22px;
        color: #5f5f5f;
        font-weight: bold;
    }

    .timer-logout-title {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: space-around;
    }

    .timer-logout-title-title {
        font-size: 16px;
        font-weight: bold;
        color: #5f5f5f;
        margin-left: 12px;
    }
</style>
